import * as Yup from 'yup';

const phoneRegExp = /^\+\d{1,3}\d{8,12}$/;

export const registerSchema = (t: any) => Yup.object({
    email: Yup.string()
        .email(t('validation.email'))
        .required(t('validation.required', { field: t('auth.email') })),
    password: Yup.string()
        .min(8, t('validation.password.min', { count: 8 }))
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            t('validation.password.matches')
        )
        .required(t('validation.required', { field: t('auth.password') })),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], t('validation.passwordMatch'))
        .required(t('validation.required', { field: t('auth.confirmPassword') })),
    first_name: Yup.string()
        .trim()
        .min(2, t('validation.name.min', { field: t('auth.firstName'), count: 2 }))
        .matches(/.*\S.*/, t('validation.noSpacesOnlyFirstName'))
        .required(t('validation.required', { field: t('auth.firstName') })),

    last_name: Yup.string()
        .trim()
        .min(2, t('validation.name.min', { field: t('auth.lastName'), count: 2 }))
        .matches(/.*\S.*/, t('validation.noSpacesOnlyLastName'))
        .required(t('validation.required', { field: t('auth.lastName') })),

    phone: Yup.string()
        .matches(phoneRegExp, t('validation.phone'))
        .required(t('validation.required', { field: t('auth.phone') })),
    address: Yup.string()
        .trim()
        .matches(/.*\S.*/, 'Address cannot be empty or only spaces')
        .required('Address is required'),
    country: Yup.string()
        .required(t('validation.required', { field: t('auth.country') })),
    state: Yup.string()
        .required(t('validation.required', { field: t('auth.state') })),
    age_range: Yup.string()
        .required(t('validation.required', { field: t('auth.ageRange') })),
    gender: Yup.string()
        .required(t('validation.required', { field: t('auth.gender') })),
    school_name: Yup.string()
        .trim()
        .matches(/.*\S.*/, t('validation.noSpacesOnly', { field: t('auth.schoolName') }))
        .required(t('validation.required', { field: t('auth.schoolName') })),

    school_district: Yup.string()
        .required(t('validation.required', { field: t('auth.schoolDistrict') }))
});

export const loginSchema = (t: any) => Yup.object({
    email: Yup.string()
        .email(t('validation.email'))
        .required(t('validation.required', { field: t('auth.email') })),
    password: Yup.string()
        .required(t('validation.required', { field: t('auth.password') }))
});

export const passwordResetRequestSchema = Yup.object({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email is required')
});

export const resetPasswordSchema = Yup.object({
    password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            'Password must contain at least one uppercase letter, one lowercase letter, and one number'
        )
        .required('Password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Please confirm your password')
});

export const profileUpdateSchema = Yup.object({
    first_name: Yup.string()
        .min(2, 'First name must be at least 2 characters')
        .required('First name is required'),
    last_name: Yup.string()
        .min(2, 'Last name must be at least 2 characters')
        .required('Last name is required'),
    phone: Yup.string()
        .matches(phoneRegExp, 'Please enter a valid phone number')
        .required('Phone number is required'),
    address: Yup.string()
        .trim()
        .matches(/.*\S.*/, 'Address cannot be empty or only spaces')
        .required('Address is required'),
    city: Yup.string(),
    country: Yup.string()
        .required('Country is required'),
    state: Yup.string()
        .required('State is required'),
    age_range: Yup.string()
        .required('Age range is required'),
    gender: Yup.string()
        .required('Gender is required'),
    school_name: Yup.string()
        .required('School name is required'),
    school_district: Yup.string()
        .required('School district is required')
});
